import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { map } from 'rxjs/internal/operators/map';
import { AppComponent } from 'src/app/app.component';
import { DataService } from 'src/app/services/data.service';
import {StandardPermitPage} from '../../modals/standard-permit/standard-permit.page';
import {WaitingListPage} from '../../modals/waiting-list/waiting-list.page'
import {TemporaryPermitPage} from '../../modals/temporary-permit/temporary-permit.page'
import { LoaderService } from 'src/app/services/loader.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { PlatformService } from 'src/app/platform.service';
import { DisclaimersService } from 'src/app/services/disclaimers.service';
import { LanguageService } from 'src/app/services/language.service';
import { VehiclesService } from 'src/app/services/vehicles.service';
import { LotImagePage } from 'src/app/modals/lot-image/lot-image.page';
import { environment } from 'src/environments/environment';
import { LotpasswordComponent } from 'src/app/popovers/lotpassword/lotpassword.component';
import { EnterlotpasswordPage } from '../enterlotpassword/enterlotpassword.page';
@Component({
  selector: 'app-permits',
  templateUrl: './permits.page.html',
  styleUrls: ['./permits.page.scss'],
})
export class PermitsPage implements OnDestroy {
  environment = environment
  @ViewChildren("divs") private divs: QueryList<ElementRef>;
  errorMessage:any=''
  subscriptionEvent;
  loaded=false;
  searchItem;
  permits = {};
  
  constructor(
    private popoverController: PopoverController,
    private errorHandlerSRV:ErrorHandlerService,
    private renderer: Renderer2,
    public vehiclesSRV:VehiclesService,
    public disclaimerSRV:DisclaimersService,
    public platformSRV:PlatformService,
    private errorSRV:ErrorHandlerService,
    public loaderSRV:LoaderService,
    public appComp:AppComponent,
    public modalController: ModalController,
    private router: Router,
    public dataService: DataService
  ) {}
  async presentLotPasswordPopover(e: Event) {
    const popover = await this.popoverController.create({
      component: LotpasswordComponent,
      event: e,
    });

    await popover.present();

    const { role } = await popover.onDidDismiss();
  }
  async openImageModal(imageSrc){
    
    const desktopModal = await this.modalController.create({
      component: LotImagePage,
      cssClass: 'modal-desktop-transparent',
      componentProps: {
       imageSource:imageSrc
      }
    });
    const mobileModal = await this.modalController.create({
      component: LotImagePage,
      cssClass: 'modal-mobile-transparent',
      componentProps: {
       imageSource:imageSrc
      }
    });
    const tabletModal = await this.modalController.create({
      component: LotImagePage,
      cssClass: 'modal-tablet-transparent',
      componentProps: {
       imageSource:imageSrc
      }
    });
    if(this.platformSRV.device=='desktop'){
      return await desktopModal.present();
    } else if(this.platformSRV.device=='mobile'){
      return await mobileModal.present();
    } else if(this.platformSRV.device=='tablet'){
      return await tabletModal.present();
    }
    
  }
  openScanner(){
    this.router.navigateByUrl('/qrscanner')
  }
  
  showMore(e:Event){
    
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[1], "display", 'none');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[2], "display", 'block');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "overflow", 'visible');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "height", 'auto');
    
  }
  showLess(e:Event){
    
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[1], "display", 'block');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[2], "display", 'none');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "overflow", 'hidden');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "height", '60px');
    
  }
  async openTemporaryPermitModal(lot){
    var data={
      lot:lot,
      isModal:true
    }
    const desktopModal = await this.modalController.create({
      component: TemporaryPermitPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps: {
       ...data
      }
    });
    const mobileModal = await this.modalController.create({
      component: TemporaryPermitPage,
      breakpoints: [0.5, 0.85,1],
      initialBreakpoint: 1,
      cssClass: 'modal-mobile-normal',
      componentProps: {
       ...data
      }
    });
    const tabletModal = await this.modalController.create({
      component: TemporaryPermitPage,
      breakpoints: [0.5, 0.85,1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps: {
       ...data
      }
    });
    var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
    
      await modal.present()
    
    
   
    
  }
  async openWaitingList(lot) {
    var data={
      lotNameId:lot.LotNameID,
      isModal:true
    }
    const desktopModal = await this.modalController.create({
      component: WaitingListPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps: {
        ...data
      }
    });
    const mobileModal = await this.modalController.create({
      component: WaitingListPage,
      breakpoints: [0.5,  0.85,1],
      initialBreakpoint: 1,
      cssClass: 'modal-mobile-normal',
      componentProps: {
        ...data
      }
    });
    const tabletModal = await this.modalController.create({
      component: WaitingListPage,
      breakpoints: [0.5,  0.85,1],
      initialBreakpoint: 1,
      cssClass: 'modal-tablet-normal',
      componentProps: {
        ...data
      }
    });

    var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
      await modal.present()

    modal.onDidDismiss().then(res => {
      if (res.data == 'refresh') {
        this.loadPermits()
      }
    })
  }

  async openStandardPermitModal(lot) {
    var data={
      lotNameId:lot.LotNameID,
      isModal:true
    }
    
    const desktopModal = await this.modalController.create({
      component: StandardPermitPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps: {
        ...data
      }
    });
    const mobileModal = await this.modalController.create({
      component: StandardPermitPage,
      breakpoints: [0.5,  0.85,1],
      initialBreakpoint: 1,
      cssClass: 'modal-mobile-normal',
      componentProps: {
        ...data
      }
    });
    const tabletModal = await this.modalController.create({
      component: StandardPermitPage,
      breakpoints: [0.5,  0.85,1],
      initialBreakpoint: 1,
      cssClass: 'modal-tablet-normal',
      componentProps: {
        ...data
      }
    });
    var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
      await modal.present()
    
    
    
  }
  sortByDuration = (a: any, b: any) => {
    return a.value.duration - b.value.duration;
  }
  loadPermits(){
    
    this.dataService.getData('permits')
    .pipe(map(data=>{
      if(data['status']=="success"){
      Object.entries(data['lots']).forEach(element => {
        element[1]['PermitTypes'].forEach(permit => {
          if(permit.counts.MaxTempPermits==0){
            permit['allowTempPermit']=true
          } else {
            if(permit.counts.temp_remaining<1){
              permit['allowTempPermit']=false
            } else {
              permit['allowTempPermit']=true
            }
          }
          if(permit['activestart']){
            permit['activestart']=permit['activestart'].substr(0,10)  
          }
          
          permit.LotType = data['permitWindowTypes'][permit.LotType]
          
        });
      });
      return data}
      else {
        this.ngOnDestroy()
        return
        
      }
    }))
    .subscribe({
      next:res=>{
        this.permits=res
        this.loaded=true;
        this.loaderSRV.progressBarLoading=false
        this.errorMessage=''
         this.renderOtherHtml()
       
        
      },error:er=>{
        this.errorHandlerSRV.displayErrorMessage(er,false).then(response=>{
          this.errorMessage=response['message']
          this.loaded=true
          this.loaderSRV.progressBarLoading=false
        })
       
      }
    },)
  }
  ionViewDidEnter() {
  
    var disclaimer;
    disclaimer= this.disclaimerSRV.disclaimers.find(disclaimer=>disclaimer['data_trigger']=='permits-lots-loaded' && disclaimer['locale']==this.dataService.selected )
    
    
    if(disclaimer && disclaimer['active']){
      this.dataService.createAndOpenModal(disclaimer).then(data=>{
        if(data){
         this.proceed()
        }
      })
    } else {
      this.proceed()
      
      
    }
   
  }
  renderOtherHtml(){
    setTimeout(() => {
      this.divs.forEach(data=>{
        if(data.nativeElement.children[0].clientHeight<70){
          //hide show more button
          this.renderer.setStyle(data.nativeElement.children[1], "display", 'none');
          //hide show less button
          this.renderer.setStyle(data.nativeElement.children[2], "display", 'none');
        } else {
          //hide show less button
          this.renderer.setStyle(data.nativeElement.children[2], "display", 'none');
          this.renderer.setStyle(data.nativeElement.children[0], "height", '70px');
          this.renderer.setStyle(data.nativeElement.children[0], "overflow", 'hidden');
        }
        
      })
     }, 10);
  }
  proceed(){
    
      this.subscriptionEvent = this.dataService.isAuthenticated.subscribe(isLoggedIn=>{
        if(isLoggedIn){
          this.loadPermits()
        } else {
          this.loaded=false;
          this.permits={}
          this.ngOnDestroy()
        }
      })
    
  }
  ngOnDestroy() {
    if(this.subscriptionEvent){
      this.subscriptionEvent.unsubscribe()
    }
     
   }
   search(ev){
    this.loaded=false;
    this.loaded=true
    this.renderOtherHtml()

  }
}
